
export default async (to, from, next) => {
  _seo()
  next()
}
